import ResourceProvider from '../ResourceProvider';

const TimesheetResource = ResourceProvider('/resource/timesheets');

export default TimesheetResource;
